<template>
  <div>
    <ul class="breadcrumbs">
      <li>
        <a href="/i">{{ $t('sitemap_home') }}</a>
        <span style="margin-left: 10px">/</span>
      </li>
      <li v-for="(path, index) in locationPath" :key="index">
        <div>
          <a
            v-if="
              (index !== locationPath.length - 1 || linkLast) && path.webPath
            "
            :href="path.webPath"
            >{{ path.name }}</a
          >
          <span v-else>{{ path.name }}</span>
          <span
            v-if="index !== locationPath.length - 1"
            style="margin-left: 10px"
            >/</span
          >
        </div>
      </li>
    </ul>
    <script type="application/ld+json">
      {{ ldJson }}
    </script>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumbs',

  props: {
    locationPath: {
      type: Array,
      default: () => []
    },
    linkLast: {
      type: Boolean,
      default: () => true
    }
  },

  data: function () {
    return {
      ldJson: {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: []
      }
    };
  },

  created() {
    let idx = 1;
    this.ldJson.itemListElement.push({
      '@type': 'ListItem',
      position: idx++,
      name: 'Hem',
      item: `${location.origin}/`
    });

    for (const path of this.locationPath) {
      this.ldJson.itemListElement.push({
        '@type': 'ListItem',
        position: idx++,
        name: path.name,
        item: `${location.origin}${path.webPath}`
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.breadcrumbs {
  list-style: none;
  padding: 0;
  margin: 0;
  gap: 8px;
  margin-bottom: 14px;

  @media ($large-screen) {
    display: flex;
  }
}
</style>
